// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qb-1";
export var stateContainer = "_qb-0";